import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, CheckCircle2, CreditCard } from 'lucide-react';
import { Countdown } from './Countdown';
import { PlanSelector } from './PlanSelector';
export function FinalCTA() {
  return <section className="py-10 md:py-20 px-4" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-2xl md:text-4xl font-bold text-navy-dark text-center mb-4 md:mb-8" data-id="element-133">
          No dejes pasar esta oportunidad
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-red-600 text-white p-3 md:p-4 rounded-lg text-center mb-6 md:mb-12" data-id="element-134">
          <p className="font-bold mb-1 md:mb-2 text-xs md:text-base" data-id="element-135">
            Termina en
          </p>
          <Countdown className="text-lg md:text-2xl font-bold" data-id="element-136" />
        </motion.div>

        <PlanSelector anchorStandard={49990} anchorPremium={69990} data-id="element-137" />

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-[10px] md:text-sm text-gray-600 mt-6 md:mt-8" data-id="element-138">
          <span className="flex items-center gap-1" data-id="element-139">
            <Lock className="w-3 h-3 md:w-4 md:h-4" data-id="element-140" /> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-141">
            <Zap className="w-3 h-3 md:w-4 md:h-4" data-id="element-142" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1" data-id="element-143">
            <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4" data-id="element-144" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-145">
            <CreditCard className="w-3 h-3 md:w-4 md:h-4" data-id="element-146" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}